import posthog from 'posthog-js';

/** @type {string | undefined} */
const POSTHOG_API_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

/** @type {string | undefined} */
const POSTHOG_API_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

/**
 * @type {Partial<import('posthog-js').PostHogConfig>}
 */
const posthogOptions = {
  api_host: POSTHOG_API_HOST,
  defaults: '2025-05-24',
};

export const initialisePostHog = () => {
  if (!POSTHOG_API_KEY) {
    return;
  }

  posthog.init(POSTHOG_API_KEY, posthogOptions);
};
